// extracted by mini-css-extract-plugin
var _1 = "kHM6azHWpdBIhBeppa5Q";
var _2 = "oWHqtbhQPAgjxkiqJwGQ";
var _3 = "FFJNqKfmBz8IyYaNLI4R";
export { _1 as "heading", _2 as "reset", _3 as "wrapper" }
